import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionRequestTakeoverPayload } from 'api/actions/revision-request-takeover/revision-request-takeover-payload';
import { RevisionRequestTakeoverPathParameters } from 'api/actions/revision-request-takeover/revision-request-takeover-path-parameters';
import { RevisionRequestTakeoverResponse } from 'api/actions/revision-request-takeover/revision-request-takeover-response';

type RevisionRequestTakeoverQueryParameters = Record<string, any>;

/**
 * The path of the RevisionRequestTakeover action.
 */
export const revisionRequestTakeoverActionPath = new SweetPath<keyof RevisionRequestTakeoverPathParameters>(
  '/api/revision/request-takeover/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionRequestTakeover actions.
 */
export default function createRevisionRequestTakeoverAction(axios: AxiosInstance) {
  return function revisionRequestTakeoverAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionRequestTakeoverPathParameters;
    query?: RevisionRequestTakeoverQueryParameters;
    payload: RevisionRequestTakeoverPayload;
  }) {
    const path = revisionRequestTakeoverActionPath.insert(parameters);

    return axios.request<RevisionRequestTakeoverResponse, RevisionRequestTakeoverResponse>({
      method: 'post',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
